// extracted by mini-css-extract-plugin
export default {"webshopLink":"WebshopLink_webshopLink__cb4Zx","webshopLinkText":"WebshopLink_webshopLinkText__19WK9","webshopLinkSmall":"WebshopLink_webshopLinkSmall__oDtkY"};